import { initProductSelection, initStepGating } from './shared.js';
import initSelect2 from '../helpers/select2.js';
import { addNewPrototype } from '../helpers/helper.js';

const initInternalReportForm = () => {
	const affectsEl = $('#internal_report_affects');
	if(!affectsEl.length){
		return;
	}

	const productSection = $('[data-internal-report-products]');
	const processSection = $('[data-internal-report-processes]');
	const orderNr = $('#order_nr');
	const quantityAffected = $('#quantity_affected_items');
	const productSelectClass = '.internal-report-product-select';
	const processField = $('#internal_report_processes');
	const internalDescription = $('#internal_report_description');
	const affectsOther = $('#internal_report_affects_other');

	const toggleGroup = (field, show) => {
		if(!field.length){
			return;
		}
		const isSection = field.is('[data-internal-report-products], [data-internal-report-processes]');
		const group = isSection || field.hasClass('form-group') ? field : field.closest('.form-group');
		if(show){
			group.removeClass('d-none');
		}else{
			group.addClass('d-none');
		}
	};

	const toggleAffectsFields = () => {
		const value = affectsEl.val();
		const showArticle = value === 'article';
		const showProcess = value === 'internal_process';
		const showOther = value === 'other';
		const showDescription = showArticle || showProcess || showOther;

		toggleGroup(productSection, showArticle);
		toggleGroup(orderNr, showArticle);
		toggleGroup(quantityAffected, showArticle);
		toggleGroup(processSection.length ? processSection : processField, showProcess);
		toggleGroup(internalDescription, showDescription);
		toggleGroup(affectsOther, showOther);
	};

	let syncingQuantity = false;
	const getQuantityInputs = () => {
		return $(`${productSelectClass}`).map((index, element) => {
			const row = $(element).closest('.main-row');
			return row.find('input[name$="[quantity]"]').get(0);
		}).get().filter(Boolean);
	};

	const syncQuantityAffected = (force = false) => {
		if(!quantityAffected.length){
			return;
		}
		if(!force && quantityAffected.data('manual')){
			return;
		}

		let sum = 0;
		let hasValue = false;

		getQuantityInputs().forEach((input) => {
			const raw = $(input).val();
			if(raw === null || raw === undefined || raw === ''){
				return;
			}
			const normalized = raw.toString().replace(',', '.');
			const value = parseFloat(normalized);
			if(Number.isNaN(value)){
				return;
			}
			hasValue = true;
			sum += value;
		});

		syncingQuantity = true;
		if(hasValue && sum > 0){
			quantityAffected.val(sum);
		}else{
			quantityAffected.val('');
		}
		syncingQuantity = false;
	};

	const bindQuantityEvents = () => {
		$(document).off('input.internal-report-quantity change.internal-report-quantity', 'input[name$="[quantity]"]');
		$(document).on('input.internal-report-quantity change.internal-report-quantity', 'input[name$="[quantity]"]', () => {
			syncQuantityAffected();
		});

		if(quantityAffected.length){
			quantityAffected.off('input.internal-report-total change.internal-report-total').on('input.internal-report-total change.internal-report-total', () => {
				if(!syncingQuantity){
					quantityAffected.data('manual', true);
				}
			});
		}
	};

	const initProductPrototype = () => {
		addNewPrototype('add-new-prototype-internal-report-product', () => {
			initSelect2();
			bindQuantityEvents();
			syncQuantityAffected();
		}, () => {
			syncQuantityAffected();
		});
	};

	affectsEl.unbind('change.internal-report-affects').bind('change.internal-report-affects', () => {
		toggleAffectsFields();
		if(affectsEl.val() === 'article'){
			syncQuantityAffected(true);
		}
	});

	toggleAffectsFields();

	initStepGating({
		containerSelector: '[data-internal-report-step]',
		messageSelector: '.internal-report-step-message',
		disabledClass: 'internal-report-step-disabled',
		eventNamespace: 'internal-report-step'
	});
	initProductSelection();
	bindQuantityEvents();
	if(!quantityAffected.val()){
		syncQuantityAffected(true);
	}
	initProductPrototype();
};

export default initInternalReportForm;
